import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  // getPendingOrders,
  RESETORDER,
  selectOrder,
  selectOrderSuccessPrint,
  selectPendingOrders,
  updateOrderDiscount,
} from "../../redux/features/order/OrderSlice";
import { IoEyeSharp } from "react-icons/io5";
import { FiX } from "react-icons/fi";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const PreviewOrder = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [discount, setDiscount] = useState();
  const [discountReason, setDiscountReason] = useState("");
  const printRef = useRef();
  const dispatch = useDispatch();
  const pendingOrders = useSelector(selectPendingOrders);
  const currentOrder = useSelector(selectOrder);
  const isSuccess = useSelector(selectOrderSuccessPrint);
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;
  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;

  const [serviceCharge, setServiceCharge] = useState(serviceCharges);

  const order = pendingOrders?.find((order) => order._id === id);

  const [printOrder, setPrintOrder] = useState(order);

  const handlePreviewOpen = () => {
    setPrintOrder(order);
    setIsOpen(true);
  };

  const handlePreviewClose = () => {
    setDiscount();
    setIsOpen(false);
  };

  useEffect(() => {
    if (isSuccess) {
      setPrintOrder(currentOrder);
      dispatch(RESETORDER());
      setDiscount();
    }
  }, [isSuccess, currentOrder]);

  if (!order) {
    return null;
  }

  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;

  const handlePrint = () => {
    const isMobile =
      /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;

    if (isMobile) {
      return;
    }
    const printContent = printRef.current;
    if (!printContent) return;

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles} 
          ${printStyles}
          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
           
            }
            .text-[.8rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
    handlePreviewClose();
  };

  const handleSubmit = async (discount, id) => {
    if (discount > 0 || serviceCharge !== serviceCharges) {
      if (discount > 0 && !discountReason) {
        toast.error("Discount reason is requried");
        return;
      } else {
        const totalAmountDiscount = discount;
        const service = serviceCharge !== serviceCharges ? serviceCharge : 0;

        await dispatch(
          updateOrderDiscount({
            totalAmountDiscount,
            discountReason,
            id,
            service,
          })
        );
        setServiceCharge(serviceCharges);

        handlePreviewClose();
      }
    } else {
      toast.error("Discount and Service Charges requried");
      return;
    }
  };

  return (
    <div>
      <button
        onClick={handlePreviewOpen}
        title="View & Print receipt"
        className="capitalize lg:px-3 px-2 rounded-xl font-bold text-white py-2 bg-blue-500"
      >
        <IoEyeSharp className="lg:size-6 size-[1.1rem]" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="bg-white w-full max-w-lg  p-6 pt-0 rounded-xl shadow-xl max-h-[90vh] overflow-y-auto scrollbar-hide shadow-[white]/50 md:mx-0 mx-3 relative">
            <div className="sticky top-0 pb-2 pt-4 bg-white">
              <div className="flex justify-between items-center">
                <div className=" capitalize font-bold text-[1.2rem]">
                  order #{order.orderNo}
                </div>
                <button onClick={handlePreviewClose}>
                  <FiX className="size-6 transform scale-125" />
                </button>
              </div>

              <>
                <div className="flex justify-between ">
                  {order.tableNo !== "parcel" && (
                    <div className="flex justify-start items-end gap-4 border-b w-max border-[#0D868C]">
                      <label className="text-[.9rem] font-semibold text-[#7D7D7D]">
                        Service Charges
                      </label>
                      <select
                        onChange={(e) => setServiceCharge(e.target.value)}
                        value={serviceCharge}
                        className=" outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3"
                      >
                        <option value={serviceCharges}>
                          {serviceCharges}%
                        </option>
                        <option value="5">5%</option>
                      </select>
                    </div>
                  )}
                  <p
                    onClick={() => handlePrint()}
                    className=" flex-none  bg-[#0D868C] cursor-pointer text-white py-2 px-4 capitalize rounded-md"
                  >
                    print
                  </p>
                </div>

                <div className="my-3 flex justify-between items-end gap-2">
                  <div className=" flex-1 flex-grow flex flex-col items-start">
                    <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                      Total Discount
                    </label>
                    <input
                      value={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                      type="number"
                      min={0}
                      step={1}
                      onWheel={(e) => e.target.blur()}
                      placeholder="Total Amount discount"
                      className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                    />
                  </div>
                  {discount > 0 && (
                    <div className=" flex-1 flex-grow flex flex-col items-start">
                      <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                        Discount Reason
                      </label>
                      <input
                        value={discountReason}
                        onChange={(e) => setDiscountReason(e.target.value)}
                        type="text"
                        placeholder="Discount reason"
                        className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                      />
                    </div>
                  )}
                  <p
                    onClick={() => handleSubmit(discount, order._id)}
                    className=" flex-none  bg-[#0D868C] cursor-pointer text-white py-2 px-4 capitalize rounded-md"
                  >
                    Save
                  </p>
                </div>
              </>
            </div>

            {/* Order details */}
            <div className=" py-4 px-4 mx-auto  rounded-xl flex flex-col gap-3  ">
              {/* Top Section */}
              <div className="w-full text-center">
                <h1 className="lg:text-[2rem] text-[1.5rem] font-bold text-[#1E1E1E]">
                  {priceSymbol}{" "}
                  {order.totalAmountDiscount > 0
                    ? (
                        order.totalAmountAfterDiscount + order?.serviceCharges
                      ).toFixed(2)
                    : (order.totalAmount + order?.serviceCharges).toFixed(2)}
                </h1>
                <h2 className="text-[#0D868C] lg:text-[1rem] text-[.8rem] font-bold capitalize">
                  Total Amount
                </h2>
              </div>

              {/* Lower Top Section */}
              <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
                <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal">
                  Waiter: <span className="capitalize">{order.username}</span>
                </p>
                <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal capitalize">
                  Table No: {order.tableNo}
                </p>
              </div>

              {/* Middle Section */}
              <div>
                {order.products?.map((item, index) => (
                  <div
                    key={item._id}
                    className={`flex items-center w-full lg:gap-6 gap-4 p-2 ${
                      index !== 0 ? "border-t border-[#DEDEDE]" : ""
                    }`}
                  >
                    <div className="flex flex-col flex-1 gap-1">
                      <h2 className="text-[#0D868C] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                        {item.name}{" "}
                      </h2>

                      {item?.name?.includes("deal") && (
                        <h2 className="text-[#0D868C] text-[.7rem] capitalize">
                          {item?.description}{" "}
                        </h2>
                      )}
                    </div>
                    <div className="flex items-center justify-between w-[40%] text-[#A9A9A9] text-[.8rem] lg:text-[1rem]">
                      <p className="w-[35%]">X{item.quantity}</p>
                      <p>
                        {priceSymbol} {item.price * item.quantity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Upper Lower Section */}
              <div>
                <p className="flex flex-col justify-between items-center lg:p-4 p-3 lg:text-[1rem] text-[.8rem] border-y-2 border-[#DEDEDE]">
                  {order?.serviceCharges > 0 && (
                    <div className="flex justify-between items-center w-full">
                      <span className="text-[#0D868C] font-medium">
                        Service Charges{" "}
                        {order.serviceChargesPercentage
                          ? order.serviceChargesPercentage
                          : serviceCharges}
                        %
                      </span>
                      <span className="text-[#868585]">
                        {priceSymbol} {order.serviceCharges.toFixed(2)}
                      </span>
                    </div>
                  )}
                  {order.totalAmountDiscount > 0 ? (
                    <div className="flex justify-between items-center w-full">
                      <span className="text-[#0D868C] font-bold">Total</span>
                      <span className="text-[#868585] flex gap-3 items-center ">
                        <span className=" line-through text-[#c2c0c0]">
                          {priceSymbol} {order.totalAmount.toFixed(2)}
                        </span>
                        {priceSymbol}{" "}
                        {order.totalAmountAfterDiscount.toFixed(2)}
                      </span>
                    </div>
                  ) : (
                    <div className="flex justify-between items-center w-full">
                      <span className="text-[#0D868C] font-bold">Total</span>
                      <span className="text-[#868585]">
                        {priceSymbol} {order.totalAmount.toFixed(2)}
                      </span>
                    </div>
                  )}
                </p>
              </div>

              {/* Lower Section */}
              <div className="flex justify-between items-center text-[#A9A9A9] lg:text-[12px] text-[10px] lg:px-4 px-3 py-2">
                <p>{dayjs(order.createdAt).format("D /M /YYYY . h:mm A")}</p>
                <p>#{order.orderNo}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="hidden invisible">
        <div ref={printRef} className="flex justify-center items-center">
          <div className=" m-1  bg-white  flex flex-col">
            <div className="text-center">
              <div className="text-center  mx-auto">
                {/* {companyLogo && <img src={companyLogo} alt="company logo" />} */}
                <h1 className="w-full text-[1rem]  text-center uppercase tracking-[.1em] ">
                  Restaurant Bill
                </h1>
              </div>
            </div>

            <div className=" py-2  rounded-xl flex flex-col gap-1  ">
              {printOrder?.orderNo && (
                <h1 className="w-full text-[.8rem] my-2 text-center uppercase tracking-[.1em] ">
                  Invoice #{printOrder.orderNo}
                </h1>
              )}

              {/* Lower Top Section */}
              <div className="flex flex-col gap-1 border-y border-[#000] py-1 px-1">
                <p className="text-black text-[10px] uppercase tracking-[.1em]  ">
                  Waiter: <span>{printOrder?.username}</span>
                </p>
                <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                  Table No: {printOrder?.tableNo}
                </p>
              </div>

              {/* Middle Section */}
              <div className="border border-[#000]">
                <div
                  className={`flex items-center w-full  border-b border-[#000]`}
                >
                  {/* <div className="flex flex-col flex-1 gap-1">
                    <h2 className="text-black text-[.7rem]   tracking-[.1em] ">
                      Item
                    </h2>
                  </div> */}
                  <div className="flex items-center justify-between w-full text-black text-[.7rem]  tracking-[.1em]  ">
                    <p className="w-[30%]  text-center py-1">Qty</p>
                    <p className="w-[35%] border-x border-[#000] text-center py-1">
                      Rate
                    </p>
                    <p className="w-[35%]  text-center py-1">Total</p>
                  </div>
                </div>
                {printOrder?.products?.map((item, index) => (
                  <div
                    key={item._id}
                    className={`flex items-start flex-col w-full`}
                  >
                    <div className="flex flex-col flex-1 gap-1 pl-1 ">
                      <h2 className="text-black text-[.7rem]  uppercase tracking-[.1em] ">
                        {index + 1}. {item.name}{" "}
                      </h2>
                      {item?.name?.includes("deal") && (
                        <h2 className="text-black text-[.6rem] uppercase tracking-[.1em] ">
                          {item?.description}{" "}
                        </h2>
                      )}
                    </div>
                    <div
                      className={`flex items-center justify-between w-full  ${
                        index !== printOrder?.products?.length - 1
                          ? "border-y"
                          : "border-t"
                      }  border-[#000] text-black text-[.7rem] uppercase tracking-[.1em]  `}
                    >
                      <p className="w-[30%] text-center ">{item?.quantity}</p>
                      <p className="w-[35%] border-x border-[#000] text-center ">
                        {item?.price}
                      </p>
                      <p className="w-[35%] text-center ">
                        {item?.price * item?.quantity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Upper Lower Section */}
              <div>
                <p className="flex flex-col justify-between items-center pb-2 pt-1 text-[.73rem] border-t border-[#000]">
                  {printOrder?.serviceCharges > 0 && (
                    <div className="flex justify-between items-center text-[.73rem] w-full">
                      <span className="text-black uppercase tracking-[.1em] ">
                        Service Charges{" "}
                        {order?.serviceChargesPercentage
                          ? order.serviceChargesPercentage
                          : serviceCharges}
                        %
                      </span>
                      <span className="text-black uppercase tracking-[.1em] ">
                        {priceSymbol} {printOrder?.serviceCharges.toFixed(2)}
                      </span>
                    </div>
                  )}
                  {printOrder?.totalAmount && (
                    <div className="flex justify-between items-center w-full text-[.8rem]">
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        Total
                      </span>
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        {priceSymbol}{" "}
                        {(
                          printOrder?.totalAmount + printOrder?.serviceCharges
                        ).toFixed(2)}
                      </span>
                    </div>
                  )}

                  {printOrder?.totalAmountDiscount > 0 && (
                    <div className="flex justify-between items-center text-[.73rem] w-full">
                      <span className="text-black uppercase tracking-[.1em] ">
                        Discount
                      </span>
                      <span className="text-black uppercase tracking-[.1em] ">
                        {priceSymbol}{" "}
                        {printOrder?.totalAmountDiscount.toFixed(2)}
                      </span>
                    </div>
                  )}
                  {printOrder?.totalAmountDiscount > 0 && (
                    <div className="flex justify-between items-center text-[.85rem] w-full border-t border-[#000]">
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        Grand Total
                      </span>
                      <span className="text-black uppercase tracking-[.1em] font-medium">
                        {priceSymbol}{" "}
                        {printOrder?.totalAmountDiscount > 0
                          ? (
                              printOrder?.totalAmountAfterDiscount +
                              printOrder?.serviceCharges
                            ).toFixed(2)
                          : (
                              printOrder?.totalAmount +
                              printOrder?.serviceCharges
                            ).toFixed(2)}
                      </span>
                    </div>
                  )}
                </p>
              </div>

              <div className="text-[.75rem]  uppercase tracking-widest  text-center">
                Thank You for Visiting
              </div>

              <div className="text-[.7rem] uppercase tracking-[.1em] font-light text-center w-full flex flex-col justify-center ">
                Powered By Eastern Tech
              </div>

              {/* Lower Section */}
              <div className="flex justify-center items-center text-black uppercase tracking-[.1em]  text-[14px] pb-6">
                <p>
                  {dayjs(printOrder?.createdAt).format("D /M /YYYY . h:mm A")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewOrder;
